import React from 'react';
import { motion } from 'framer-motion';
import { Move, X } from 'lucide-react';

/**
 * QuickGuide — the right-side "drag / pinch / scale" cheat-sheet overlay
 * inside `ViewOnWall`. Auto-hides when the user clicks the X.
 */
const QuickGuide = ({ visible, onDismiss }) => {
  if (!visible) return null;
  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 20 }}
      className="absolute top-24 right-6 bg-black/70 backdrop-blur-xl rounded-2xl p-5 max-w-xs border border-white/10"
      data-testid="vow-quick-guide"
    >
      <div className="flex items-center justify-between mb-3">
        <h4 className="text-white font-medium text-sm flex items-center gap-2">
          <Move className="w-4 h-4" />
          Quick Guide
        </h4>
        <button
          onClick={onDismiss}
          className="text-white/60 hover:text-white transition-colors"
          aria-label="Dismiss guide"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
      <ul className="text-neutral-200 text-xs space-y-2">
        <li className="flex items-start gap-2">
          <span className="text-green-400 mt-0.5">•</span>
          <span><strong>Drag</strong> artwork to reposition</span>
        </li>
        <li className="flex items-start gap-2">
          <span className="text-blue-400 mt-0.5">•</span>
          <span><strong>Pinch</strong> with two fingers to resize (or use +/−)</span>
        </li>
        <li className="flex items-start gap-2">
          <span className="text-amber-400 mt-0.5">•</span>
          <span>Adjust the <strong>Wall width in photo</strong> slider so the artwork matches your real room</span>
        </li>
        <li className="flex items-start gap-2">
          <span className="text-purple-400 mt-0.5">•</span>
          <span>Artwork scales to <strong>real dimensions</strong></span>
        </li>
      </ul>
    </motion.div>
  );
};

export default QuickGuide;
